import { IDateFilter } from 'volta/_pods/protected/bom/controller';

import Component from '@glimmer/component';
import moment from 'moment-timezone';

interface IArgs {
  dateFilter: IDateFilter;
  onFilter?: (filter: IDateFilter) => void;
}

export default class BomActiveNodesFilter extends Component<IArgs> {
  get dateFilter() {
    const { startDate, endDate } = this.args.dateFilter;
    return {
      startDate: startDate ? moment(startDate).toDate() : undefined,
      endDate: endDate ? moment(endDate).toDate() : undefined
    };
  }
}
